const InvoicePaymentStatus = {
  UNPAID: 0,
  PARTIALLY_PAID: 1,
  PAID: 2,
};

export default InvoicePaymentStatus;
